import styled from 'styled-components';
import { theme } from '../theme';
import { Box } from '../Box';
import { Tag } from '../Tag';
import { Text } from '../Text';
import React from 'react';
import { ToggleButton } from './ToggleButton';
/**
 * ### How do I pass state to the `SegmentedControl` component?
 * We recommend pulling the state up to at least the component that renders `SegmentedControl` up to at least the component that renders `SegmentedControl`, this should make it easier to pass state to the `SegmentedControl` component
 */
export const SegmentedControl = ({ options, value, onChange, showTag, styles: { tagBorder = 'marshmallowPink', tagText = 'cream', tagBg = 'marshmallowPink', selectedText = 'cream', text = 'liquorice', background, toggle, } = {}, }) => {
    return (React.createElement(ToggleWrapper, { backgroundColor: background },
        React.createElement(IndicatorWrapper, { backgroundColor: background },
            options.map((option) => {
                return (React.createElement(ToggleButton, { key: option.label, name: "toggle-version-button", value: option.value, onChange: onChange, isSelected: option.value === value, isDisabled: option.isDisabled },
                    React.createElement(StyledWrapper, null,
                        showTag && option.tag && (React.createElement(StyledTag, { bgColor: tagBg, borderColor: tagBorder, color: tagText, label: option.tag })),
                        React.createElement(StyledText, { isSelected: option.value === value, selectedTextColor: selectedText, color: text }, option.label))));
            }),
            React.createElement(ToggleIndicator, { selectedIndex: options.findIndex((option) => option.value === value), sections: options.length, toggleColor: toggle }))));
};
const BORDER_RADIUS = 25;
const StyledWrapper = styled(Box) `
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
`;
const StyledTag = styled(Tag) `
  border-radius: 100px;
`;
const StyledText = styled(Text) `
  font-weight: ${theme.font.weight.medium};
  ${({ isSelected, selectedTextColor }) => isSelected && `color: ${theme.colors[selectedTextColor]};`}
  padding: 2px 0px;
`;
const ToggleWrapper = styled(Box) `
  padding: 4px;
  background-color: ${(p) => theme.colors[p.backgroundColor ?? 'custard']};
  border-radius: ${BORDER_RADIUS}px;
`;
const IndicatorWrapper = styled(Box) `
  position: relative;
  display: flex;
  background-color: ${(p) => theme.colors[p.backgroundColor ?? 'custard']};
  border-radius: ${BORDER_RADIUS}px;
`;
const ToggleIndicator = styled(Box) `
  background-color: ${(p) => theme.colors[p.toggleColor ?? 'liquorice']};
  border-radius: ${BORDER_RADIUS}px;
  position: absolute;
  z-index: 1;
  height: 100%;
  width: ${(p) => `calc(100% / ${p.sections})`};
  transition: transform 0.4s;
  transform: ${(p) => `translateX(${p.selectedIndex * 100}%)`};
`;
//# sourceMappingURL=SegmentedControl.js.map